import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: ':test_uuid',
        name: 'landing',
        component: () => import("@/pages/LandingPage.vue"),
        meta: {
          title: 'Potenzialanalyse',
        },
      },
      {
        path: ':test_uuid/HowYouThink',
        name: 'single-choice',
        component: () => import("@/pages/SingleChoicePage.vue"),
        meta: {
          title: 'How you think',
          preventBack: true,
        },
      },
      {
        path: ':test_uuid/HowYouBehave',
        name: 'weighted-ranking',
        component: () => import("@/pages/WeightedRankingPage.vue"),
        meta: {
          title: 'How you behave',
          preventBack: true,
        },
      },
      {
        path: ':test_uuid/complete',
        name: 'complete',
        component: () => import("@/pages/ThankYouPage.vue"),
        meta: {
          title: 'Test abgeschlossen',
        },
      },
      {
        path: ':catchAll(.*)*',
        name: 'not-found',
        component: () => import("@/pages/ErrorNotFound.vue"),
        meta: {
          title: 'Nicht gefunden',
        },
      },
    ],
  },
];

export default routes;
